// Single source of truth for the focus pill's animation timings, shared by EventBarV2 and FocusPill
// so the pieces that must move in lockstep can't drift apart. There are two semantic durations:
//
//   SLIDE — the pill's FLIP slide/resize between cells (FocusPill Motion), the What/Where cells'
//           flex-basis resize, the search button's expand, and the setTimeout that releases the
//           merged shape once the slide finishes.
//   FADE  — the pill's opacity fade in/out (FocusPill Motion) and the setTimeout that keeps the pill
//           mounted through that fade before unmounting it.

// Milliseconds — setTimeout uses these directly; Motion divides by 1000 for its seconds-based API.
export const PILL_SLIDE_DURATION_MS = 300;
export const PILL_FADE_DURATION_MS = 150;

// Tailwind can't interpolate class names (the JIT only sees complete literals), so the timing lives
// here as literal class strings rather than being derived from the constants above. The `-300`
// tokens correspond to PILL_SLIDE_DURATION_MS — keep them in sync if that value ever changes.
export const CELL_RESIZE_TRANSITION_CLASSES =
  'transition-[flex-basis] delay-300 duration-300 ease-in-out motion-reduce:transition-none';
export const SEARCH_BUTTON_TRANSITION_CLASSES =
  'transition-all duration-300 ease-in-out motion-reduce:transition-none';
